function generateStars(score) {
  const full = Math.floor(score);
  const half = score % 1 >= 0.5;
  let html = "";

  for (let i = 0; i < full; i++) {
    html += '<span class="star star-on"></span>';
  }
  if (half && full < 5) {
    html += '<span class="star star-half"></span>';
  }
  return html;
}
function renderRating(data) {
  const d = typeof data === "string" ? JSON.parse(data) : data;
  const count = d.count || 0;
  const averageScore = parseFloat(d.averageScore) || 0;
  const percentRating = (averageScore / 5) * 100 || 0;
  const ratings = d.ratings || [];
  console.log(d)
  $(".top .stars").html(generateStars(averageScore));
  $(".top .custom span").text(Number(averageScore).toFixed(1));
  $(".top .number").text(count);
  $(".heurek .percent").text(percentRating + "%");
  $("body .header-top .site-name-wrapper").append($('<div class="heureka"><div class="h3">'+percentRating+'%</div> <span class="ts">zákazníků doporučuje</span> </div>'));
  $('footer#footer .hodnoceni .celkove .number').text(averageScore)
  $('footer#footer .hodnoceni .celkove .count').text(count+' hodnocení')
  $('footer#footer .hodnoceni .shop .percent').text(percentRating+'%')
  $('footer#footer .hodnoceni .shop a').text(count+' zákazníků nás hodnotilo na našem e-shopu')
  const reviewHtml = ratings
    .filter((r) => (parseFloat(r.score) || 0) === 5 && (r.description || "").length >= 50)
    .map((r) => {
      const reviewName = r.fullName || "Ověřený zákazník";
      return `
        <div class="review-item">
          <div class="header">
            <span>${parseFloat(r.score) || 0} / 5</span>
            <div class="stars">${generateStars(parseFloat(r.score) || 0)}</div>
          </div>
          <div class="vote-content">${r.description}</div>
          <div class="vote-header">
            <div class="name">${reviewName}</div>
          </div>
          <div class="verified">Ověřená recenze</div>
        </div>
      `;
    })
    .join("");

  $(".reviews").html(reviewHtml);

  if ($.fn.slick) {
    $(".reviews")
      .not(".slick-initialized")
      .slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        dots: false,
        arrows: true,
        infinite: false,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 2, slidesToScroll: 1 },
          },
          {
            breakpoint: 992,
            settings: { slidesToShow: 3, slidesToScroll: 1 },
          },
          {
            breakpoint: 767,
            settings: "unslick",
          },
        ],
      });
  }
}
const storageKeyHodnoceni = "storeRatingData-" + document.location.host;
const storageTtlHodnoceni = 30 * 60 * 1000; // platnost uložených dat: 30 minut

function loadStoredRating() {
  try {
    const time = parseInt(sessionStorage.getItem(storageKeyHodnoceni + "-time"), 10);
    const stored = sessionStorage.getItem(storageKeyHodnoceni);
    if (stored && Date.now() - time < storageTtlHodnoceni) {
      return JSON.parse(stored);
    }
  } catch (e) {}
  return null;
}

function saveStoredRating(json) {
  try {
    sessionStorage.setItem(storageKeyHodnoceni, json);
    sessionStorage.setItem(storageKeyHodnoceni + "-time", Date.now());
  } catch (e) {}
}

$(function () {
  const stored = loadStoredRating();
  if (stored) {
    renderRating(stored);
  } else {
    $.ajax({
      url: "/hodnoceni-obchodu/?jsonFormat",
      method: "GET",
      dataType: "text", // surový JSON z odpovědi, uloží se do storage beze změny
      headers: {
        "Content-Type": "application/json",
        "X-Store-Rating-Details": "true",
      },
      success: function (response) {
        saveStoredRating(response);
        renderRating(JSON.parse(response));
      },
      error: function (xhr, status, error) {
        console.error("Chyba při načítání hodnocení:", error);
      },
    });
  }

  fixReviews();
});
document.addEventListener("ShoptetDOMProductRatingsLoaded", function () {
  fixReviews();
});


function fixReviews() {
  if ($('#ratingsList').length) {
    $('#ratingsList .vote-wrap').not(':has(> .header)').each(function () {
      const $wrap = $(this);
      const score = $wrap.find('.vote-header .vote-rating .stars').first().find('.star-on').length;

      $wrap.prepend(`
        <div class="header">
          <span>${score} / 5</span>
          <div class="stars">${generateStars(score)}</div>
        </div>
      `);
      $wrap.append('<div class="verified">Ověřená recenze</div>');
    });
  }
}